export default "__VITE_ASSET__CcJNgQRL__"